import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import { UserDefinedImages } from 'cd-eft/_codegen_/openapi-generator/eft-set';
import { IGetAllProjectsObject } from 'cd-eft/models/Projects/projectsLibrary';
import { action, observable } from 'mobx';

export default class ProjectsLibraryStore {
  constructor(private appStore: any) {
    this.init();
  }

  projectTypes = {
    1: 'Design',
    4: 'Analysis',
  };

  sortByOptions = {
    0: '',
    1: 'Project Name: Ascending',
    2: 'Date: Ascending',
    3: 'Date: Descending',
  };

  workFlowStep = {
    "analysis": [
      { id: 1, name: 'Define AOI and DEM' },
      { id: 2, name: 'Define Outlet' },
      { id: 3, name: 'Edit Watershed' },
      { id: 4, name: 'Edit Land Use' },
      { id: 5, name: 'Select HSG' },
      { id: 6, name: 'Results' }
    ]
  }

  coordinateSystemOptions: ICoordinateSystemOptions[] = [
    { value: "NAD83(2011) UTM", label: "NAD83(2011) UTM", name: "NAD83(2011) UTM" }
  ]

  coordinateSystemOptionsClipDem: ICoordinateSystemOptions[] = [
    { value: "NAD83 UTM (meters)", label: "NAD83 UTM (meters)", name: "NAD83 UTM (meters)" },
    { value: "WGS 1984 (meters)", label: "WGS 1984 (meters)", name: "WGS 1984 (meters)" }
  ]

  @observable isLoading: boolean = false;
  @observable isLoadingCounter: number = 0;
  @observable loadingMsg: string = "";
  @observable projectContainerInitializing: boolean = false;
  @observable projects: IGetAllProjectsObject[] = [];
  @observable filteredProjects: IGetAllProjectsObject[] = [];
  @observable projectStatuses: any = [];
  @observable projectProjectionInfo: string = ''
  @observable projectSpatialReference?: SpatialReference = undefined;
  @observable projectSpatialRefData: any = {};
  @observable pojectionByLocationData: any = [];
  @observable xyByStateCounty: any = [];
  @observable resetZValue: boolean = false;
  @observable limitPerPage: number = 5;
  @observable sortBy: number = 0;
  @observable pageNumber: number = 1;

  @observable filterString: string = '';
  @observable filterProjectTypes: Set<number> = new Set();
  @observable filterProjectStatuses: Set<number> = new Set();

  @observable advancedSearchIsOpen: boolean = false;
  @observable isReportGenerated: boolean = false;

  @observable currentStructureList: any = [];
  @observable projectComments: any = [];
  @observable analysisComments: any = [];
  @observable structureComments: any = [];
  @observable designElementsByType: any = {};
  @observable selectedImages: number[] = [];
  @observable fileFormat: string = '';

  @observable coordinateSystemType: string = '';

  @observable designElementsImageDic: { [key: number]: UserDefinedImages[] } = {}; // { designelementID: { img data }}

  @action resetFilter() {
    this.pageNumber = 1;
    this.filterString = '';
    this.filterProjectTypes = new Set();
    this.filterProjectStatuses = new Set();
  }

  @action reset() {
    this.init();
  }

  @action init() {
    this.isLoading = false;
    this.loadingMsg = ""
    this.projects = [];
    this.filteredProjects = [];
    this.projectStatuses = [];
    this.projectComments = [];
    this.analysisComments = [];
    this.structureComments = [];
    this.projectProjectionInfo = '';
    this.projectSpatialRefData = {}
    this.pojectionByLocationData = []
    this.xyByStateCounty = [];
    this.limitPerPage = 5;
    this.sortBy = 3;
    this.pageNumber = 1;

    this.filterString = '';
    this.filterProjectTypes = new Set();
    this.filterProjectTypes.add(1);
    this.filterProjectTypes.add(4);
    this.filterProjectStatuses = new Set();
    this.designElementsByType = {};
    this.selectedImages = [];
    this.fileFormat = '';
    this.designElementsImageDic = {};
  }
  // unused
  @action.bound setLoader(value: string = '') {
    if (value.trim()) {
      this.isLoading = true;
      this.loadingMsg = value;
    } else {
      this.isLoading = false;
      this.loadingMsg = '';
    }
  }
  
  // multiple async methods using isLoading individually can cause race conditions

  @action.bound incrementLoading() {
    this.isLoadingCounter += 1;
    this.isLoading = true;
  }


  @action.bound decrementLoading() {
    this.isLoadingCounter = Math.max(0, this.isLoadingCounter - 1);
    this.isLoading = this.isLoadingCounter > 0;
  }

}





export interface ICoordinateSystemOptions {
  name: string;
  value: string;
  label?: string;
}